import { AppState } from "./AppState";
import _debug from "debug";
import appStorageFactory, {IAppStorage} from "application-storage/dist";
const debug = _debug("localStorage");

const appStateStorage = createLocalStorage('AppState');

export interface NamedLocalStorage extends IAppStorage {}
export function createLocalStorage(name: string, location: "local"|"session" = "local"): NamedLocalStorage {
  return appStorageFactory("10Duke.OrgAdmin." + name , location);
}

export function loadState(): AppState | undefined {
  const app = appStateStorage.getValue();
  if (!app) {
    return undefined;
  } else {
    return app;
  }
}

export function saveState(state: AppState): void {
  try {
    appStateStorage.setValue(state);
  } catch (err) {
    if (debug.enabled) {
      debug(`save state failed: ${err}`);
    }
  }
}
